import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import cookie from 'react-cookie';
import LibraryBooksOutlinedIcon from "@material-ui/icons/LibraryBooksOutlined";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import { checkPropTypes } from "prop-types";

import NfcIcon from "@material-ui/icons/Nfc";
import IconButton from "@material-ui/core/IconButton";

class Sidebar extends Component {

	constructor(props) {
		super(props);
		this.state = {
			self: this, checkedA: true,
			checkedB: true,
			checkedC: true};
	}

	handleChange(event) {
		//alert(event.target.name);
		/*
		if (event.target.name === "a1") {

		}
		else if (event.target.name === "a2") {

		}
		else if (event.target.name === "a3") {

		}
		*/
	    this.setState({ ...this.state, [event.target.name]: event.target.checked });
	    };

	dologout() {
	        this.removeCookie_general_complete();
	        let old_qs = cookie.load("initial_querystring");
	   if(old_qs===undefined) {
               window.location = "/";
            } else {
	           window.location = "/"+old_qs;
            }
	}

	dologout_goto_chaek() {
	        this.removeCookie_general_complete();
	        let old_qs = cookie.load("initial_querystring");
	   if(old_qs===undefined) {
               window.location = "/Home";
            } else {
	           window.location = "/Home"+old_qs;
            }
	}

	dologin() {
		window.location = "/signin_audiobook";
	}

	removeCookie(userid) {
		cookie.remove("userid", { path: '/' });
		cookie.remove("userdbid", { path: '/' });
		cookie.remove("orgid", { path: '/' });
		cookie.remove("lc", { path: '/' });
		cookie.remove("lendc", { path: '/' });
		cookie.remove("orgname", { path: '/' });
		cookie.remove("sbc", { path: '/' });
	};

	removeCookie_general_complete() {
	    cookie.remove("userid", { path: '/' });
	    cookie.remove("userdbid", { path: '/' });
	    cookie.remove("orgid", { path: '/' });
	    cookie.remove("lc", { path: '/' });
	    cookie.remove("lendc", { path: '/' });
	    cookie.remove("orgname", { path: '/' });
	    cookie.remove("sbc", { path: '/' });
	    cookie.remove("general_userid", { path: '/' });
	    cookie.remove("general_userdbid", { path: '/' });
	    cookie.remove("general_orgid", { path: '/' });
	    cookie.remove("general_lc", { path: '/' });
	    cookie.remove("general_lendc", { path: '/' });
	    cookie.remove("general_orgname", { path: '/' });
	    cookie.remove("general_sbc", { path: '/' });
	};

	getOS() {
		var userAgent = window.navigator.userAgent,
			platform = window.navigator.platform,
			macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
			windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
			iosPlatforms = ['iPhone', 'iPad', 'iPod'],
			os = null;

		if (macosPlatforms.indexOf(platform) !== -1) {
			os = 'Mac OS';
		} else if (iosPlatforms.indexOf(platform) !== -1) {
			os = 'iOS';
		} else if (windowsPlatforms.indexOf(platform) !== -1) {
			os = 'Windows';
		} else if (/Android/.test(userAgent)) {
			os = 'Android';
		} else if (!os && /Linux/.test(platform)) {
			os = 'Linux';
		}

		return os;
	}

	render() {

		let struserid = cookie.load("general_userid");
		let struserdbid = cookie.load("general_userdbid");
		let lc = cookie.load("general_lc");
		let lendbookc = cookie.load("general_lendc");
		let orgname = cookie.load("general_orgname");
		let sbc = cookie.load("general_sbc");
		let orgid = cookie.load("general_orgid");
		if (typeof orgid === 'undefined')
			orgid = 0;
		if (typeof orgname === 'undefined')
			orgname = '';
                    //<h5 className="account-title2">이용 가능 콘텐츠: 오디오북 미리듣기,NFC태그 전체듣기</h5>
                    //<h5 className="account-title2">이용 가능 콘텐츠: 오디오북 {sbc}권</h5>
		if (struserid != null && struserid.length > 0) {

			let os = this.getOS();
			var strSettingLink = "mcbab://setting/" + orgid + "/" + encodeURI(orgname.trim());
			if (os === 'iOS') {
			}
			else {
				strSettingLink = "mcbab://setting/" + orgid + "/" + encodeURI(orgname.trim()) + "/";
            }


            var login_head;

            if (orgname === "익명사용자" || orgname ==="더책") {

                if(struserid==="체험사용자") {
                    login_head = <div className="sidebar-module sidebar-account">
                        <h3 className="account-title">{struserid}</h3>
                        <h5 className="account-title2">{lc}번째 방문하셨습니다.</h5>
                    </div>;
                } else {
                    login_head = <div className="sidebar-module sidebar-account">
                        <h5 className="account-title2">{lc}번째 방문하셨습니다.</h5>
                    </div>;
                }
            } else {

                login_head =<div className="sidebar-module sidebar-account">
                    <h3 className="account-title">{struserid}</h3>
                    <h5 className="account-title2">{lc}번째 방문하셨습니다.</h5>
                    <h4 className="account-title2-bold">{orgname}</h4>
                </div>;
            }



			return (
                <div className="sidebar">
                    {login_head}

					<div className="sidebar-module3">
						<h4><PersonOutlineOutlinedIcon /> <Link to={"/library_audiobook"}>내 서재 바로 가기</Link></h4>
						<br/>
					</div>

					<div className="sidebar-module-left">
						<h4><Link to={
							{
								pathname: `/InfoView5_AudioBook`,
								state: {
									title: '공지사항',
                                    url: 'https://support.thechaek.com/1ee7b17b-715f-432b-877f-af1dbba8f2ef'
								}
							}
						}>공지사항</Link></h4>
						<br />
						<h4><Link to={
							{
								pathname: `/InfoView2_AudioBook`,
								state: {
                                    title: '이용방법',
                                    url: 'https://support.thechaek.com/d0463dc4-74da-4f6b-8875-7d895c69e623'
								}
							}
						}>이용방법</Link></h4>
                    <br />
                    <h4><Link to={
                        {
                            pathname: `/InfoView6_AudioBook`,
                            state: {
                                title: '오디오 라이브러리 서비스 안내 ',
                                url: 'https://support.thechaek.com/392f9a21-3330-41df-bcb4-c4b99f754eab'
                            }
                        }
                    }>오디오 라이브러리 서비스 안내</Link></h4>
						<br />
						<h4><a href={strSettingLink}>설정</a></h4>
						
					</div>

					<div className="sidebar-module-left">
						<h4><Link to={
							{
								pathname: `/InfoView4_AudioBook`,
								state: {
									title: '이용약관',
                                    url: 'https://support.thechaek.com/7791384e-e63c-4c1f-839e-51822251003f'
								}
		
					}
						}> 이용약관</Link>
						</h4><br />
						<h4><Link to={
							{
								pathname: `/InfoView3_AudioBook`,
								state: {
									title: '개인정보보호정책',
                                    url: 'https://support.thechaek.com/959eb2e5-2a31-49e3-a597-1203ea796efd'
                            }
							}
						}>개인정보보호정책</Link></h4>
			<br />
					<h4>고객센터 <a href={`mailto:cs@changbi.com`} ><font color={'blue'}>cs@changbi.com</font></a></h4>

					</div>
                    <div className="sidebar-module-bottom-orig"><center>
                        <Button variant="contained" style={{
                            width: "200px",
                            zIndex: 10,
                            borderRadius: 5,
                            color: "white",
                            backgroundColor: "#f6ad55",
                            padding: "5px 5px",
                            fontSize: "18px"
                        }}  fullWidth="true"  onClick={() => this.dologout_goto_chaek()}>
                                로그아웃
						    </Button></center>
					</div>
				</div>
			);
		}


			//<br />
            //            <h4><a href={`mcbab://read_nfctag/for=report&userdbid=${struserdbid}`}
            //            >불편 사항 신고 <NfcIcon /></a></h4>
        var old_log_btns= 
                    <div className="sidebar-module-bottom-buttons">
                        <Button variant="contained" style={{
                            marginLeft: "1px",
                            width: "80%",
                            borderRadius: 5,
                            color: "white",
                                backgroundColor: "#f6ad55",
                            padding: "5px 5px",
                            fontSize: "18px"
                        }}  fullWidth="true"  onClick={() => this.dologout_goto_chaek()}>
                                더책 서비스로 이동
						    </Button>
                        <br/>
                        <br/>
                        <Button variant="contained"
                                    style={{
                                width: "75%",
                                borderRadius: 5,
                                color: "white",
                                backgroundColor: "#888888",
                                padding: "5px 5px",
                                fontSize: "18px"
                            }} 
                        fullWidth="true" onClick={() => this.dologout()}>
                                로그아웃
                        </Button>
					</div>
        ;

		return (
			<div className="sidebar">
                    <br />

                <div className="sidebar-module-left">
                    <h4><Link to={
                        {
                            pathname: `/InfoView5_AudioBook`,
                            state: {
                                title: '공지사항',
                                url: 'https://support.thechaek.com/1ee7b17b-715f-432b-877f-af1dbba8f2ef'
                            }
                        }
                    }>공지사항</Link></h4>
                    <br />
                    <h4><Link to={
                        {
                            pathname: `/InfoView2_AudioBook`,
                            state: {
                                title: '이용방법',
                                url: 'https://support.thechaek.com/d0463dc4-74da-4f6b-8875-7d895c69e623'
                            }
                        }
                    }>이용방법</Link></h4>
                    <br />
                    <h4><Link to={
                        {
                            pathname: `/InfoView6_AudioBook`,
                            state: {
                                title: '오디오 라이브러리 서비스 안내 ',
                                url: 'https://support.thechaek.com/392f9a21-3330-41df-bcb4-c4b99f754eab'
                            }
                        }
                    }>오디오 라이브러리 서비스 안내</Link></h4>

						<br />
						<h4><a href={strSettingLink}>설정</a></h4>
						<br />
                </div>

                <div className="sidebar-module-left">
                    <h4><Link to={
                        {
                            pathname: `/InfoView4_AudioBook`,
                            state: {
                                title: '이용약관',
                                url: 'https://support.thechaek.com/7791384e-e63c-4c1f-839e-51822251003f'
                            }

                        }
                    }> 이용약관</Link>
                    </h4><br />
                    <h4><Link to={
                        {
                            pathname: `/InfoView3_AudioBook`,
                            state: {
                                title: '개인정보보호정책',
                                url: 'https://support.thechaek.com/959eb2e5-2a31-49e3-a597-1203ea796efd'
                            }
                        }
                    }>개인정보보호정책</Link></h4>
			<br />
						
					<h4>고객센터 <a href={`mailto:cs@changbi.com`} ><font color={'blue'}>cs@changbi.com</font></a></h4>


                </div>

                <div className="sidebar-module-bottom-orig"><center>
                        <br/>
                        <Button variant="contained"
                                    style={{
                                width: "200px",
                                zIndex: 10,
                                borderRadius: 5,
                                color: "white",
                                backgroundColor: "#f6ad55",
                                padding: "5px 5px",
                                fontSize: "18px"
                            }} 
                        fullWidth="true" onClick={() => this.dologin()}>
                            로그인
						    </Button></center>
					</div>

            </div>
		);
	}
}

export default Sidebar;
